import React from 'react';
import { useTranslation } from 'react-i18next';
import { OEMCompatibility } from '@1po/1po-bff-fe-spec/generated/catalog/references/iam/model/Reference';
import { Text } from 'UI';

interface OEMCompatibilityLineProps {
  oemCompatibility: OEMCompatibility | undefined;
}

export const OEMCompatibilityLine: React.FC<OEMCompatibilityLineProps> = ({ oemCompatibility }) => {
  const { t } = useTranslation();

  if (!oemCompatibility?.code) return null;

  const displayText = `${oemCompatibility.supplierLabel ?? ''} ${oemCompatibility.code}`.trim();

  return (
    <Text type="sm" color="grey55" data-cy="oem-compatibility-line">
      {t('catalog.reference_card.oem_compatibility', 'OEM compatibility')}: {displayText}
    </Text>
  );
};

export default OEMCompatibilityLine;
